module.exports = __webpack_public_path__ + "36ac310f10eb400f596dc27e4c5de36f.fbx";